export default {
  duration: '.275s',
  type: 'ease-in-out',
  curve: 'cubic-bezier(0.650, 0.000, 0.450, 1.000)',
};
